import React from "react";
import type { KeyBenefitsBlock } from "@/types/product";
import { fixedCmsImage } from "@/utils/cmsImage";
import shared from "../ProductDetailContent.module.css";
import styles from "./KeyBenefitsSection.module.css";

export const KeyBenefitsSection: React.FC<{ block: KeyBenefitsBlock }> = ({
  block,
}) => {
  const items = (block.items ?? []).slice(0, 6);
  if (!items.length) return null;

  return (
    <section className={`${shared.section} ${shared.bgVeryDark}`}>
      <div
        className={shared.inner}
        style={{ ["--benefits-count" as string]: items.length }}
      >
        <div className={styles.grid}>
          {items.map((item) => (
            <div key={item.id} className={styles.item}>
              {item.icon?.url && (
                <span className={styles.iconCirc}>
                  <img
                    {...fixedCmsImage(item.icon.url, { width: 28 })}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                  />
                </span>
              )}
              {item.heading && (
                <h3 className={styles.heading}>{item.heading}</h3>
              )}
              {item.subtext && <p className={styles.subtext}>{item.subtext}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyBenefitsSection;
